exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".libs__clickable__3n5n2 {\n    cursor: pointer;\n}\n\n.libs__movable__2JsFd {\n    cursor: move;\n}\n\n.libs__grabbable__2zMyW {\n    cursor: -webkit-grab;\n    cursor: grab;\n}\n\n.libs__grabbable__2zMyW:active {\n    cursor: -webkit-grabbing;\n    cursor: grabbing;\n}\n", ""]);

// exports
exports.locals = {
	"clickable": "libs__clickable__3n5n2",
	"movable": "libs__movable__2JsFd",
	"grabbable": "libs__grabbable__2zMyW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[folder]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib!./client/src/style/libs/interaction.css
// module id = JUbx
// module chunks = 0